export enum EFileGroup {
  AVATAR = "avatar",
  DOCS_FOR_CARRIERS = "docsForCarriers",
  ACCEPTANCE_WINDOW = "acceptanceWindow",
  SIDELETTERS = "sideletters",
  RFX_FAMILY = "tenderFamily",
  COMPANY_IMAGES = "companyImages"
}
